import React from 'react';
import SmartDisplayIcon from '@mui/icons-material/SmartDisplay';

import {
  Container,
  VehicleArea,
  AreaTitle,
  Row,
  Column,
  VideoContainer,
  AreaTitleContainer,
  AreaSubtitle,
} from './styles';

export const VehicleD2DVideos = props => {
  const { updatedAuction } = props;

  const urlMotor = updatedAuction?.summary?.additionalInfo?.videos?.urlMotor;
  const urlExhaust = updatedAuction?.summary?.additionalInfo?.videos?.urlExhaust;
  const urlExchange = updatedAuction?.summary?.additionalInfo?.videos?.urlExchange;

  // Build list of valid URLs (non-empty strings)
  const urls = [urlMotor, urlExhaust, urlExchange].filter(
    u => typeof u === 'string' && u.trim().length > 0
  );

  // Guard: if none are present, render nothing
  if (urls.length === 0) return null;

  return (
    <Container>
      <VehicleArea>
        <AreaTitleContainer>
          <AreaTitle>
            <SmartDisplayIcon sx={{ marginRight: 1 }} />
            Vídeos
          </AreaTitle>
        </AreaTitleContainer>
        <Row>
          {urls.map((url, idx) => (
            <Column key={idx}>
              <VideoContainer>
                <iframe
                  src={url}
                  width="100%"
                  height="100%"
                  frameBorder="0"
                  allow="autoplay; fullscreen; picture-in-picture"
                  allowFullScreen
                  title={`Vídeo ${idx + 1}`}
                />
              </VideoContainer>
            </Column>
          ))}
        </Row>
      </VehicleArea>
    </Container>
  );
};
